import { render, staticRenderFns } from "./FileDownload.vue?vue&type=template&id=5263f811&scoped=true&"
import script from "./FileDownload.vue?vue&type=script&lang=js&"
export * from "./FileDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5263f811",
  null
  
)

export default component.exports